import axios from 'axios'
export default {
  getSearchCourseList: (config = {}) => axios.get(`/searchList`, config), // 搜索课程列表
  getSearchFilter: (config = {}) => axios.get(`/searchSift`, config), // 删选条件
}



// WEBPACK FOOTER //
// ./src/networks/api/SearchPage/index.js